// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"253":"d50ed415","490":"96835ea8","513":"982e1551","676":"2dc2ce17","852":"fb1a8b85","939":"2ec7c95e"}[chunkId] + ".css";
};